module.exports = __webpack_public_path__ + "static/media/logo-header-sp.4795e7b4.svg";